var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-back"},[_c('span',{staticClass:"header-back-btn",attrs:{"role":"button"},on:{"click":_vm.group1.historyBack}},[_c('IcArrowLeft',{staticClass:"icn lg"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }